function filterImageData(modalData: any) {
    const imageData = {
        image: {
            default:
                modalData?.backgroundImage?.fields?.default?.fields?.file?.url,
            desktop: modalData?.backgroundImage?.fields?.web?.fields?.file?.url,
            livingRoom:
                modalData?.backgroundImage?.fields?.livingRoom?.fields?.file
                    ?.url,
            mobile: modalData?.backgroundImage?.fields?.mobile?.fields?.file
                ?.url,
            tablet: modalData?.backgroundImage?.fields?.tablet?.fields?.file
                ?.url,
            web: modalData?.backgroundImage?.fields?.web?.fields?.file?.url
        }
    };
    return imageData;
}

export { filterImageData }